.header {
  display: flex;
  justify-content: space-between;
}

.headerTitle {
  display: flex;
  flex-direction: column;
}

.profileContainer {
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 2rem 0;
}

.profileCard {
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e1e1e1;
  padding-left: 3rem;
  margin-bottom: 1rem;
  gap: 1rem;
}

.profileTitles {
  display: flex;
  flex-direction: column;
  width: 20%;
}

.profileTitle {
  padding-left: 1rem;
}

.profileTitleBtn {
  display: flex;
  width: 100%;
  align-items: flex-start;
  text-align: left;
  border-radius: 0.5rem;
  padding: 1.5rem 0;
}

.profileTitleBtnFocused {
  display: flex;
  width: 100%;
  align-items: flex-start;
  text-align: left;
  border-radius: 0.5rem;
  padding: 1.5rem 0;
  background-color: var(--profile-active-bg-color) !important;
}

.profileDivider {
  height: 1px;
  border-top: 1px solid #e1e1e1;
}

.profileTitleBtn:hover {
  background-color: var(--profile-active-bg-color) !important;
}

.profileDetails {
  width: 75%;
}

.selectDepositAcntContainer {
  display: flex;
  gap: 2rem;
}

.selectedDepositAcnt {
  border: 1px solid var(--button-border-hover-color);
}

.referralDropDowns {
  display: flex;
  gap: 0.5rem;
}

.dropdownBtn {
  display: flex;
  gap: 0.3rem;
  align-items: center;
}

@media only screen and (max-width: 550px) {
  .profileCard {
    padding-left: 0.7rem;
  }

  .profileContainer {
    margin: 1rem 0;
  }

  .profileTitle {
    padding: 0 0.2rem 0 0.5rem;
  }

  .profileTitles {
    width: 28%;
  }

  .profileDetails {
    width: 70%;
  }
}
